import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { push } from 'react-router-redux';
import moment from 'moment';
import {
  Container,
  Dropdown,
} from 'semantic-ui-react';

import NavBar from '../../components/NavBar';
import { TRANSLATION_FILES } from '../../constants/translation';
import OpportunityList from '../../components/Opportunities/OpportunityList';

moment.locale('en-gb');

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdmin: PropTypes.bool,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        himsIsEnabled: PropTypes.bool,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }
  handleOnLoading = (loading) => {
    this.setState({ loading });
  }
  himsIsEnabled = () => {
    const { appConfig } = this.props;
    return appConfig && appConfig.data && appConfig.data.himsIsEnabled;
  }
  handleManageClick = (e, data) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(push(`/opportunities/${data.value}`));
  }
  render() {
    const { t, auth } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Bookings')}
          rightNav={(auth.isHeadquarters || auth.isAdminBasic) ? (
            <Dropdown item text={t('Manage')}>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={this.handleManageClick}
                  value="manage_refunds/"
                >
                  {t('Manage Refunds')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null}
        />
        <OpportunityList
          onLoading={this.handleOnLoading}
        />
      </Container>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.screens)(connect(List.mapStateToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Opportunities/List.jsx